module.exports = __webpack_public_path__ + "static/agut-red-acbbf265ab94a5a4201c670d95eacdb0.png";